import axiosInstance from "../../../api/axios";

export interface Region {
  code: null;
  created_at: string;
  created_by_id: number;
  deleted_at: null;
  id: number;
  is_deleted: boolean;
  mfr_id: string;
  mfr_row_guid: string;
  name: string;
  updated_at: string;
  updated_by_id: null;
}

export interface Zone {
  code: null;
  created_at: string;
  created_by_id: number;
  deleted_at: null;
  id: number;
  is_deleted: boolean;
  mfr_id: string;
  mfr_row_guid: string;
  name: string;
  region_id: number;
  updated_at: string;
  updated_by_id: null;
}

export interface Woreda {
  code: null;
  created_at: string;
  created_by_id: number;
  deleted_at: null;
  id: number;
  is_deleted: boolean;
  mfr_id: string;
  mfr_row_guid: string;
  name: string;
  updated_at: string;
  updated_by_id: null;
}

export const getRegion = () => {
  return axiosInstance
    .get("/region")
    .then((response) => {
      return response.data as Region[];
    })
    .catch((error: any) => {
      console.log(error);
    });
};

export const getZone = (id: string) => {
  return axiosInstance
    .get("/zone/ByRegionId/" + id)
    .then((response: any) => {
      return response.data as Zone[];
    })
    .catch((error: any) => {
      console.log(error);
    });
};

export const getWoreda = (id: string) => {
  return axiosInstance
    .get("/woreda/ByZoneId/" + id)
    .then((response: any) => {
      return response.data as Woreda[];
    })
    .catch((error: any) => {
      console.log(error);
    });
};

export const getFacility = (id: string) => {
  return axiosInstance
    .get("/facility/ByWoredaId/" + id)
    .then((response: any) => {
      return response.data;
    })
    .catch((error: any) => {
      console.log(error);
    });
};
